import * as Yup from 'yup';

export const CadastroEmailNFeValidation = Yup.object({
  email: Yup.string().required('Insira um e-mail').matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Verifique se o e-mail está correto, com @ e ponto'),
  emailConfirmation: Yup.string().required('Insira um e-mail').matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Verifique se o e-mail está correto, com @ e ponto')
    .test('emails-match', 'Os e-mails digitados estão diferentes', function (value) {
      return this.parent.email === value;
    }),
});
